function initMap() {
  var location1 = { lat: 51.92229145797064, lng: 4.490219917778809 };
  var location2 = { lat: 51.358372345157036, lng: 5.309317499670787 };

  var mapStyle = [
    {
      featureType: 'all',
      elementType: 'geometry',
      stylers: [{ color: '#f5f5f5' }],
    },
    {
      featureType: 'all',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{ color: '#a7a7a7' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#c9c9c9' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#808080' }],
    },
  ];
  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 9,
    center: { lat: 51.6403, lng: 4.9 },
    styles: mapStyle,
  });

  var marker1 = new google.maps.Marker({
    position: location1,
    map: map,
    title: 'Marker 1',
  });

  var marker2 = new google.maps.Marker({
    position: location2,
    map: map,
    title: 'Marker 2',
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMap();
});
document.addEventListener('shopify:section:load', function (event) {
  initMap();
});
document.addEventListener('shopify:section:select', function (event) {
  initMap();
});